const leftArrow = `
  <?xml version="1.0" encoding="utf-8"?>
  <svg viewBox="-1.0095806121826172 -1.0289530754089355 14.483792304992676 10.08852481842041" width="13px" height="9px" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" stroke-linecap="round" stroke="#404040">
      <path d="M1.44117647,3.88235294 L12.4411765,3.88235294" stroke-width="2"/>
      <polyline stroke-width="2" stroke-linejoin="round" points="4 0 0 4 4 8.02057087"/>
    </g>
  </svg>
`;

const rightArrow = `
  <?xml version="1.0" encoding="utf-8"?>
  <svg viewBox="-1.0095806121826172 -1.0289530754089355 14.483792304992676 10.08852481842041" width="13px" height="9px" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" stroke-linecap="round" stroke="#404040" transform="matrix(-1, 0, 0, 1, 12.441176, 0)">
      <path d="M1.44117647,3.88235294 L12.4411765,3.88235294" stroke-width="2"/>
      <polyline stroke-width="2" stroke-linejoin="round" points="4 0 0 4 4 8.02057087"/>
    </g>
  </svg>
`;

// The second data point (zero-indexed) is always the baseline
const baselineIndex = 1;
let actualLabel;
let projectedLabel;
let leftArrowNode;
let rightArrowNode;
const xOffset = 20;
let yOffset;
const yMargin = 36;
const yPadding = 8;

function drawRectangle(svgContainer, getDateFromIndex, x, y) {
  const rectY = y.range()[1] - yMargin - yPadding;
  const height = Math.abs(y.range()[1] - y.range()[0]) + yMargin + yPadding;
  const left = 0;
  const xPos = x(getDateFromIndex(baselineIndex));
  svgContainer
    .append('rect')
    .attr('x', left)
    .attr('y', rectY)
    .attr('width', xPos)
    .attr('height', height)
    .style('fill', '#F3F3F3');
}

function drawLabels(svgContainer, getDateFromIndex, x, y) {
  const xPos = x(getDateFromIndex(baselineIndex));
  const ticks = y.ticks();
  const midpointOfLast2Ticks =
    (ticks[ticks.length - 1] + ticks[ticks.length - 2]) / 2;
  yOffset = y(midpointOfLast2Ticks) - yMargin;
  actualLabel = svgContainer
    .append('text')
    .attr('text-anchor', 'end')
    .attr('dx', -xOffset);

  projectedLabel = svgContainer
    .append('text')
    .attr('text-anchor', 'start')
    .attr('dx', xOffset);

  // Apply shared properties
  [actualLabel, projectedLabel].forEach(el => {
    el
      .style('fill', '#404040')
      .attr('alignment-baseline', 'central')
      .attr('y', yOffset)
      .attr('x', xPos);
  });

  leftArrowNode = svgContainer.append('g').html(leftArrow);
  rightArrowNode = svgContainer.append('g').html(rightArrow);
}

let firstUpdate = true;

function update(svgContainer, getDateFromIndex, x, y) {
  const desktop = window.matchMedia('(min-width: 600px)').matches;
  let arrowWidth;
  let arrowHeight;
  let xSpacing;
  let yDelta;
  if (desktop) {
    projectedLabel.text('Projected growth');
    actualLabel.text('Actual growth');
    arrowWidth = 13;
    arrowHeight = 9;
    xSpacing = 20;
    yDelta = 3;
  } else {
    // Shorter labels for mobile
    projectedLabel.text('Projected');
    actualLabel.text('Actual');
    arrowWidth = 26;
    arrowHeight = 18;
    xSpacing = 40;
    yDelta = 7;
  }

  [actualLabel, projectedLabel].forEach(el => {
    el.style('font-size', d => (desktop ? '0.75rem' : '1.5rem'));
  });

  [rightArrowNode, leftArrowNode].forEach(el => {
    el.select('svg').attr('width', arrowWidth).attr('height', arrowHeight);
  });

  // Firefox can't compute the BBox of a node that hasn't rendered yet.
  // https://bugzilla.mozilla.org/show_bug.cgi?id=612118
  // Reported:	7 years ago :)
  // We need to return early.
  if (firstUpdate) {
    firstUpdate = false;
    return;
  }
  // Resize left arrow
  const bboxLeft = actualLabel.node().getBBox();
  leftArrowNode.attr(
    'transform',
    `translate(${bboxLeft.x - xSpacing},${yOffset - yDelta})`
  );

  // Resize right arrow
  const bboxRight = projectedLabel.node().getBBox();
  rightArrowNode.attr(
    'transform',
    `translate(${bboxRight.x + bboxRight.width + xSpacing - arrowWidth},${yOffset - yDelta})`
  );
}

export default {
  drawRectangle,
  drawLabels,
  update,
};



// WEBPACK FOOTER //
// ./src/components/singleClusterProjectionsLineGraph/actualAndProjectedGrowth.js